// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccountTypeController from "./account_type_controller"
application.register("account-type", AccountTypeController)

import ActivitySelectionController from "./activity_selection_controller"
application.register("activity-selection", ActivitySelectionController)

import AutoRefreshController from "./auto_refresh_controller"
application.register("auto-refresh", AutoRefreshController)

import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)

import Bridge__AuthStateController from "./bridge/auth_state_controller"
application.register("bridge--auth-state", Bridge__AuthStateController)

import Bridge__ReloadTabController from "./bridge/reload_tab_controller"
application.register("bridge--reload-tab", Bridge__ReloadTabController)

import BulkSelectController from "./bulk_select_controller"
application.register("bulk-select", BulkSelectController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import CalendarPopulateController from "./calendar_populate_controller"
application.register("calendar-populate", CalendarPopulateController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EmbedResizeController from "./embed_resize_controller"
application.register("embed-resize", EmbedResizeController)

import FacetedFilterController from "./faceted_filter_controller"
application.register("faceted-filter", FacetedFilterController)

import FacetedSearchController from "./faceted_search_controller"
application.register("faceted-search", FacetedSearchController)

import FilterModalController from "./filter_modal_controller"
application.register("filter-modal", FilterModalController)

import FilterParamsController from "./filter_params_controller"
application.register("filter-params", FilterParamsController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import FormSubmitSpinnerController from "./form_submit_spinner_controller"
application.register("form-submit-spinner", FormSubmitSpinnerController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LocationSelectionController from "./location_selection_controller"
application.register("location-selection", LocationSelectionController)

import LrkBulkSelectionController from "./lrk_bulk_selection_controller"
application.register("lrk-bulk-selection", LrkBulkSelectionController)

import LrkPickerController from "./lrk_picker_controller"
application.register("lrk-picker", LrkPickerController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import PdfDownloadController from "./pdf_download_controller"
application.register("pdf-download", PdfDownloadController)

import PlanController from "./plan_controller"
application.register("plan", PlanController)

import PromotionalCommitmentController from "./promotional_commitment_controller"
application.register("promotional-commitment", PromotionalCommitmentController)

import RecurrenceFieldsController from "./recurrence_fields_controller"
application.register("recurrence-fields", RecurrenceFieldsController)

import RegistrationLocationSelectionController from "./registration_location_selection_controller"
application.register("registration-location-selection", RegistrationLocationSelectionController)

import ScrollPaddingController from "./scroll_padding_controller"
application.register("scroll-padding", ScrollPaddingController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SliderController from "./slider_controller"
application.register("slider", SliderController)

import SlideupModalController from "./slideup_modal_controller"
application.register("slideup-modal", SlideupModalController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SubscriptionUpgradeController from "./subscription_upgrade_controller"
application.register("subscription-upgrade", SubscriptionUpgradeController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import TomSelectFilterController from "./tom_select_filter_controller"
application.register("tom-select-filter", TomSelectFilterController)

import TurnstileController from "./turnstile_controller"
application.register("turnstile", TurnstileController)

import VersionCheckController from "./version_check_controller"
application.register("version-check", VersionCheckController)

import VgoPaymentToggleController from "./vgo_payment_toggle_controller"
application.register("vgo-payment-toggle", VgoPaymentToggleController)

import VideoPlayerController from "./video_player_controller"
application.register("video-player", VideoPlayerController)
